import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// Tiempo de guardado en localstorage
const TTL_MILISEGUNDOS = 24 * 60 * 60 * 1000; // 24 horas

const useFetchWithCache = (url, cacheKey) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    //Verificar guardado en local
    const storedItem = localStorage.getItem(cacheKey);
    const now = new Date().getTime();

    if (storedItem) {
      const item = JSON.parse(storedItem);
      // Si esta dentro del tiempo
      if (now < item.expiry) {
        setData(item.value);
        setLoading(false);
        return;
      } else {
        localStorage.removeItem(cacheKey);
      }
    }

    // If no item in localstorage
    setLoading(true);
    try {
      const response = await axios.get(url);
      const dataAPI = response.data;

      // Guardar en localStorage
      const itemToStore = {
        value: dataAPI,
        expiry: now + TTL_MILISEGUNDOS,
      };
      localStorage.setItem(cacheKey, JSON.stringify(itemToStore));

      // Actualizar state de data
      setData(dataAPI);
      setError(null);
    } catch (err) {
      console.error(`Error fetching ${url}:`, err);
      setError("Error al obtener datos de la API.");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [url, cacheKey]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useFetchWithCache;